import React from 'react';
import { LoadingSpinner } from 'mypages-library';
import styles from 'common/PageTemplate/PageTemplate.module.scss';
import PageTemplate from 'common/PageTemplate/PageTemplate';

const RequestingToken = () => (
  <PageTemplate showLanguageMenu={false}>
    <section className={styles.spinnerContainer}>
      <LoadingSpinner relative isLoading size="large" dataTestId="spinner" />
    </section>
  </PageTemplate>
);
export default RequestingToken;
